import React, { useEffect, useState, useRef } from "react"
import PropTypes from "prop-types"
import { withTranslation } from "react-i18next"
import { getVideoRoomList } from "helpers/backend_helper"
import { Select, ConfigProvider } from "antd"
import { Col, Row } from "reactstrap"
const { Option } = Select;

const SelectVideoRoom = props => {
  const [options, setOptions] = useState([])
  const [loading, setLoading] = useState(false)

  const abortRef = useRef(null)
  useEffect(() => {
    abortRef.current = new AbortController()
    return () => abortRef.current.abort()
  }, [])

  // Get carephones for dropdown
  const getData = () => {
    setLoading(true)
    getVideoRoomList(abortRef.current).then(result => {
      if (result.statusCode == 200 && result.entries) {
        let opts = []
        for (const entry of result.entries) {
          let temp = new Object()
          temp.label = entry.roomName
          temp.value = entry.roomName
          opts.push(temp)
        }
        setOptions(opts)
      }
    })
    .catch(e => {
      console.log(e)
    })
    .finally(() => {
      setLoading(false)
    })
  }

  // Selection changed
  const handleChange = newSelection => {
    if (props.onChange != null) {
      props.onChange(newSelection)
    }
  }

  // Custom empty/Data not found dropdown
  const customizeRenderEmpty = () => (
    <div className="mt-3" style={{ textAlign: "center" }}>
      {loading
        ? <p>{props.t("Loading")}</p>
        : <p>{props.t("No entries found")}</p>
      }
    </div>
  )

  // Dropdown visibility, get data at first
  const visibilityChanged = (visible) => {
    if (visible && options.length == 0 && !loading) {
      getData()
    }
  }

  return (
    <div>
      <ConfigProvider renderEmpty={customizeRenderEmpty}>
        <div className="config-provider">
        <Select
          showSearch 
          loading={loading}
          onDropdownVisibleChange={visibilityChanged}
          value={props.selection}
          mode={props.multiple ? "multiple": null}
          allowClear={props.clearable != null ? props.clearable : true}
          placeholder={props.t("Select video number")}
          style={{ width: 100 + "%" }}
          onChange={handleChange}
          filterOption={(inputValue, option) => {
            return (
              option.label?.toLowerCase().includes(inputValue.toLowerCase())
            );
          }}
        >
          {options.map((item, index) => { 
            return (
              <Option key={item.value} value={item.value} label={item.label}>
                <Row type="flex" justify="start">
                  <Col className="col-auto">{item.label}</Col>
                </Row>
              </Option>
            )
          })}
        </Select>
      </div>
      </ConfigProvider>
    </div>
  )
}

SelectVideoRoom.propTypes = {
  t: PropTypes.any,
  selection: PropTypes.string,
  onChange: PropTypes.func,
  multiple: PropTypes.bool,
  clearable: PropTypes.bool,
}

export default withTranslation()(SelectVideoRoom)